import { Observable, Subscriber } from 'rxjs';

// Bullhorn stores the data type and content separately
export interface IAttachmentFile {
  contentType: string;
  fileContent: string;
  name: string;
}

export class BullhornFileReaderService {
  getFileContents(file: File): Observable<IAttachmentFile> {
    const reader = new FileReader();

    return Observable.create((observer: Subscriber<IAttachmentFile>): void => {
      reader.onload = (e) => {
        observer.next(this.bhFileFromBase64(file.name, reader.result as string));
        observer.complete();
      };

      reader.onerror = (e) => {
        console.log(reader.error);
        reader.abort(); // is this required?
        // ToDo: observable error
      };

      reader.readAsDataURL(file);
    });
  }

  recombineToBase64(bhFile: IAttachmentFile): string {
    return `data:${bhFile.contentType};base64,${bhFile.fileContent}`;
  }

  private bhFileFromBase64(fileName: string, base64Image: string): IAttachmentFile {
    const base64 = this.getFileContent(base64Image);
    const contentType = this.getFileType(base64Image);
    return { name: fileName, fileContent: base64, contentType: contentType };
  }

  private getFileContent(base64String: string): string {
    // strip the data-url declaration (e.g. data:text/plain;base64,)
    const index = base64String.indexOf(',');
    return base64String.substring(index + 1);
  }

  private getFileType(base64String: string): string {
    // strip the data-url declaration (e.g. data:text/plain;base64,)
    const dataColon = base64String.indexOf(':');
    const dataSemiColon = base64String.indexOf(';');
    return base64String.substring(dataColon + 1, dataSemiColon);
  }
}
